import type { PlanType } from '@/stores/user-store'

// Plan hierarchy from lowest to highest
const PLAN_HIERARCHY: PlanType[] = ['free', 'starter', 'creator', 'pro', 'ultimate']

/**
 * Get the next N available upgrade plans based on current plan.
 * Never includes the current plan.
 * 
 * @param currentPlan - User's current plan
 * @param count - Number of plans to return (default 2)
 * @param minimumPlan - Optional minimum plan to start from (for features that require a specific plan)
 */
export function getNextUpgradePlans(
  currentPlan: PlanType, 
  count: number = 2,
  minimumPlan?: PlanType
): PlanType[] {
  const currentIndex = PLAN_HIERARCHY.indexOf(currentPlan)
  if (currentIndex === -1) return ['starter', 'creator'] // Fallback for unknown plan
  
  // Determine the starting index for available plans
  let startIndex = currentIndex + 1
  
  // If a minimum plan is specified and it's higher than the next plan, start from there
  if (minimumPlan) {
    const minimumIndex = PLAN_HIERARCHY.indexOf(minimumPlan)
    if (minimumIndex > startIndex) {
      startIndex = minimumIndex
    }
  }
  
  // Get plans from the starting point
  const availablePlans = PLAN_HIERARCHY.slice(startIndex)
  
  // Return up to `count` plans
  return availablePlans.slice(0, count)
}

/**
 * Check if user is on the highest plan (no upgrades available)
 */
export function isMaxPlan(currentPlan: PlanType): boolean {
  return currentPlan === 'ultimate'
}
